import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronDown = () => {
  return (
    <g>
      <path d="m8 11.77a.7494.7494 0 0 1 -.53-.22l-6.04-6.04a.75.75 0 1 1 1.0607-1.06l5.5093 5.5095 5.5088-5.51a.75.75 0 0 1 1.0612 1.0605l-6.0392 6.04a.75.75 0 0 1 -.5308.22z" />
    </g>
  );
};

export default withIcon(IconChevronDown);
